import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import userStore from "../zustand/userStore";
import { logout } from "../auth/authSlice";

const UserHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userData, removeUser } = userStore((state) => ({
    userData: state.user,
    removeUser: state.removeUser,
  }));

  const handleLogout = () => {
    dispatch(logout());
    // if (removeUser) {
    //   removeUser();
    // }
    navigate("/login");
  };

  const institutionName = userData?.school_name?.trim() || "";
  const accountHolderName = userData?.admin_name?.trim() || "";
  const displayName = userData?.name || accountHolderName || institutionName || "User";

  return (
    <>
      <style>{`
        /* ── Top Info Bar ── */
        .header-top-info-bar {
          width: 100%;
          background: #EFF1F1;
          padding: 5px 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 24px;
          font-family: Arial, sans-serif;
        }

        .header-top-info-marquee-wrapper { display: none; }
        .header-top-info-mobile { display: none; }

        @media (max-width: 991px) {
          .header-top-info-bar {
            position: relative;
            top: auto;
            left: auto;
            z-index: auto;
            padding: 4px 12px;
            gap: 0;
            flex-direction: column;
            align-items: center;
          }
          .header-top-info-desktop { display: none !important; }
          .header-top-info-marquee-wrapper {
            display: none !important;
          }
          .header-top-info-mobile {
            display: flex !important;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding: 4px 12px 2px;
            gap: 1px;
            font-size: 13px;
            color: rgba(32, 32, 32, 0.86);
            position: relative;
            top: auto;
            left: auto;
          }
          .header-top-info-mobile p {
            margin: 0;
            line-height: 1.2;
            text-align: center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
          }
          .main-navbar-mobile {
            margin-top: 0;
          }
        }

        .navbar-brand img {
          max-width: 120px;
          height: auto;
        }

        .navbar {
          padding: 10px 12px !important;
        }

        @media (max-width: 991px) {
          .navbar {
            padding: 4px 6px !important;
          }
          .navbar-brand {
            padding: 2px 4px !important;
            margin: 0 !important;
          }
          .navbar-brand img {
            max-width: 95px !important;
          }

          #userDropdown {
            font-size: 12px !important;
            padding: 4px 8px !important;
            line-height: 1.2 !important;
          }

          #userDropdown i {
            font-size: 12px !important;
            margin-right: 4px !important;
          }

          .dropdown.me-3 {
            margin-right: 0.5rem !important;
          }
        }

        /* Mobile Contact Info */
        @media (max-width: 991px) {
          .mobile-contact-info {
            display: flex !important;
            flex-direction: row !important;
            flex-wrap: nowrap !important;
            width: 100% !important;
            background: linear-gradient(135deg, #007bff 0%, #0056b3 100%) !important;
            padding: 3px 4px !important;
            justify-content: center !important;
            align-items: center !important;
            gap: 6px !important;
            position: relative !important;
            top: auto !important;
            left: auto !important;
            z-index: 1001 !important;
            overflow-x: auto !important;
          }

          .mobile-contact-numbers {
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 6px !important;
            width: auto !important;
            flex-shrink: 0 !important;
            line-height: 1 !important;
            margin: 0 !important;
            padding: 0 !important;
          }

          .mobile-contact-info a {
            color: #ffffff !important;
            text-decoration: none !important;
            font-weight: 600 !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 2px !important;
            font-size: 9px !important;
            line-height: 1 !important;
            margin: 0 !important;
            padding: 0 !important;
            white-space: nowrap !important;
          }

          .mobile-contact-info a svg {
            width: 8px !important;
            height: 8px !important;
          }

          .mobile-contact-info .working-hours {
            font-size: 9px !important;
            font-weight: 600 !important;
            color: rgba(255,255,255,0.95) !important;
            border-left: 1px solid rgba(255,255,255,0.4) !important;
            padding-left: 6px !important;
            text-align: center !important;
            line-height: 1 !important;
            margin: 0 !important;
            white-space: nowrap !important;
            flex-shrink: 0 !important;
          }
        }

        @media (min-width: 992px) {
          .mobile-contact-info {
            display: none !important;
          }
        }
      `}</style>

      {/* Top Info Bar */}
      <div className="header-top-info-bar">
        <span className="header-top-info-desktop" style={{ fontSize: "16px", color: "rgba(32, 32, 32, 0.86)", fontFamily: "Arial, sans-serif" }}>
          DocMaster's Head Quarters @ The Electronic City, A 75 Sector 63 Noida
        </span>
        <span className="header-top-info-desktop" style={{ color: "rgba(0,0,0,0.2)" }}>|</span>
        <span className="header-top-info-desktop" style={{ fontSize: "16px", color: "rgba(32, 32, 32, 0.86)", fontFamily: "Arial, sans-serif" }}>
          Associate of Shri Subhash Parasram Electronic Park Private Limited
        </span>
        <div className="header-top-info-mobile">
          <p>DocMaster Head Office - A 75 Sector 63 Noida</p>
          <p> Division of Shri Subhash Parasram Electronic Park Pvt Ltd</p>
        </div>
      </div>

      {/* Mobile Top Contact Bar */}
      <div className="mobile-contact-info">
        <div className="mobile-contact-numbers">
          <a href="https://wa.me/919289440049?text=Hi%2C%20I%20want%20to%20know%20more%20about%20DocMaster%20services.">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              fill="#ffffff"
              viewBox="0 0 24 24"
            >
              <path d="M20.52 3.48A11.8 11.8 0 0 0 12.05 0C5.5 0 .19 5.31.19 11.86c0 2.09.55 4.13 1.6 5.92L0 24l6.39-1.67a11.83 11.83 0 0 0 5.66 1.45h.01c6.55 0 11.86-5.31 11.86-11.86 0-3.17-1.23-6.15-3.4-8.44zM12.06 21.7a9.8 9.8 0 0 1-5-1.38l-.36-.21-3.79 1 1.01-3.7-.23-.38a9.8 9.8 0 1 1 8.37 4.67zm5.44-7.35c-.3-.15-1.78-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.35.23-.65.08-.3-.15-1.28-.47-2.43-1.5-.9-.8-1.5-1.78-1.68-2.08-.18-.3-.02-.46.13-.6.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.68-1.63-.94-2.24-.25-.6-.5-.52-.68-.53h-.58c-.2 0-.53.08-.8.38-.28.3-1.05 1.03-1.05 2.5 0 1.48 1.08 2.9 1.23 3.1.15.2 2.12 3.24 5.14 4.54.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.78-.73 2.03-1.44.25-.7.25-1.3.18-1.44-.08-.15-.28-.23-.58-.38z" />
            </svg>
            9289 44 00 49
          </a>
          <a href="tel:+919289440049">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              fill="#ffffff"
              viewBox="0 0 24 24"
            >
              <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" />
            </svg>
            9289 44 00 49
          </a>
        </div>
        <span className="working-hours">Mon-sat (10:00 AM to 5:00 PM)</span>
      </div>

      <nav
        className="navbar navbar-light w-100 px-3 main-navbar-mobile bg-white"
        style={{ position: "relative", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}
      >
        <div className="container-fluid px-0 d-flex justify-content-between align-items-center">
          <a href="/" className="navbar-brand p-1 px-2 rounded">
            <img
              src="/images/docmasterLogo.png"
              alt="DocMaster Logo"
              className="logo img-fluid"
            />
          </a>

          {/* Desktop Contact Info */}
          <div className="desktop-nav d-none d-lg-flex align-items-center gap-3">
            <a
              href="https://wa.me/919289440049?text=Hi%2C%20I%20want%20to%20know%20more%20about%20DocMaster%20services."
              style={{ display: "flex", alignItems: "center", gap: "6px", color: "#25D366", fontWeight: "600", fontSize: "16px", textDecoration: "none" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#25D366" viewBox="0 0 24 24"><path d="M20.52 3.48A11.8 11.8 0 0 0 12.05 0C5.5 0 .19 5.31.19 11.86c0 2.09.55 4.13 1.6 5.92L0 24l6.39-1.67a11.83 11.83 0 0 0 5.66 1.45h.01c6.55 0 11.86-5.31 11.86-11.86 0-3.17-1.23-6.15-3.4-8.44zM12.06 21.7a9.8 9.8 0 0 1-5-1.38l-.36-.21-3.79 1 1.01-3.7-.23-.38a9.8 9.8 0 1 1 8.37 4.67zm5.44-7.35c-.3-.15-1.78-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.18.2-.35.23-.65.08-.3-.15-1.28-.47-2.43-1.5-.9-.8-1.5-1.78-1.68-2.08-.18-.3-.02-.46.13-.6.14-.14.3-.35.45-.53.15-.18.2-.3.3-.5.1-.2.05-.38-.03-.53-.08-.15-.68-1.63-.94-2.24-.25-.6-.5-.52-.68-.53h-.58c-.2 0-.53.08-.8.38-.28.3-1.05 1.03-1.05 2.5 0 1.48 1.08 2.9 1.23 3.1.15.2 2.12 3.24 5.14 4.54.72.31 1.28.5 1.72.64.72.23 1.38.2 1.9.12.58-.09 1.78-.73 2.03-1.44.25-.7.25-1.3.18-1.44-.08-.15-.28-.23-.58-.38z" /></svg>
              9289 44 00 49
            </a>
            <span style={{ color: "#ccc" }}>|</span>
            <a href="tel:+919289440049" style={{ display: "flex", alignItems: "center", gap: "6px", color: "#555", fontWeight: "600", fontSize: "16px", textDecoration: "none" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="#555" viewBox="0 0 24 24"><path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z" /></svg>
              9289 44 00 49
            </a>
          </div>

          {/* Right User Dropdown Menu */}
          <div className="dropdown me-3">
            <button
              className="btn dropdown-toggle d-flex align-items-center"
              style={{ background: "transparent", border: "none" }}
              type="button"
              id="userDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-user me-2"></i>
              {displayName}
            </button>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="userDropdown"
            >
              <li>
                <Link to="/profile" className="dropdown-item">
                  Profile
                </Link>
              </li>
              <li>
                <span
                  className="dropdown-item"
                  onClick={handleLogout}
                  style={{ cursor: "pointer" }}
                >
                  <i className="fa fa-sign-out me-2"></i> Log Out
                </span>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default UserHeader;
